import Accordion from '@components/Accordion';
import Column from '@components/Column';

import useTermCategoryHistory from './hooks/useTermCategoryHistory';
import PolicyRow from './PolicyRow';
import styles from './styles.module.scss';

function Policies() {
  const histories = useTermCategoryHistory();
  console.log(histories);
  return (
        <Accordion title='서비스 이용'>
            <Column className={styles.container}>
                {histories?.map((history) => (
                    <PolicyRow termCategory={history}
                               key={history.id} />
                ))}
            </Column>
        </Accordion>
  );
}

export default Policies;
